<template>
    <div class="column">
        <div class="columns">
            <div class="column">
                <div class="box box-green has-text-left" v-if="activeDetails">
                    <span class="icon is-clickable has-text-white is-pulled-right" @click="activeDetails = false">
                        <i class="fas fa-times"></i>
                    </span>
                    <h2 class="subtitle has-text-white has-text-weight-bold is-baskerville">{{ models[model].name }}</h2>
                    <p class="has-text-white"><b>{{ $t('Kivilaji') }}:</b> {{ models[model].stone.desc }}</p>
                    <p class="has-text-white"><b>{{ $t('Tekstit ja koristeet') }}:</b> {{ models[model].color.desc }}</p>
                    <p class="has-text-white"><b>{{ $t('Fontit') }}:</b> {{ models[model].font.desc }}</p>
                    <p class="has-text-white"><b>{{ $t('Koristeet') }}:</b> {{ models[model].decoration.desc }}</p>
                    <p class="has-text-white" v-if="models[model].decoration2"><b>{{ $t('Koristeet') }}:</b> {{ models[model].decoration2.desc }}</p>
                    <p class="has-text-white"><b>{{ $t('Koot') }}:</b> {{ models[model].size.desc }}</p>
                    <p class="has-text-white" v-if="models[model].side.desc"><b>{{ $t('Hautakiven sivut') }}:</b> {{ models[model].side.desc }}</p>
                    <p class="has-text-white"><b>{{ $t('Pohjakivi') }}:</b> {{ models[model].bottom.desc }}</p>
                    <p class="has-text-white" v-if="size !== ''"><b>{{ $t('Perushinta') }}:</b> {{ models[model].size.options[size].price }} €</p>
                    <p class="has-text-white" v-if="models[model].design_stone === true">{{ $t('design_stone_help') }}</p>
                    <button class="button is-white has-text-info" @click="goToModel()">{{ $t('Vaihda design') }}</button>
                </div>
                <div class="box" v-else>
                    <div class="columns is-pulled-right design-details-box">
                        <span class="icon is-clickable has-text-info" @click="activeDetails = true">
                            <i class="fas fa-info-circle"></i>
                        </span>
                    </div>
                    <div class="columns is-flex is-vcentered is-centered" :class="[{'design-box': models[model].bottom.options[bottom].class || model == 16}, model == 16 ? models[model].size.options[size].class+'-erottamattomat' : models[model].size.options[size].class]" v-if="stone !== '' && size !== '' && bottom !== ''">
                        <div v-if="model == 15 || model == 16 || model == 17 || model == 18" class="has-text-left design-area" :class="models[model].stone.options[stone].class + models[model].stone.options[stone].bg">
                            <div v-if="models[model].stone.options[stone].option" class="design-area-option" :class="models[model].stone.options[stone].option"></div>
                            <div class="design-text-area" :class="[models[model].color.options[color].class, models[model].font.options[font].class]">
                                <div v-if="model == 15" class="columns is-mobile">
                                    <div class="column is-4 is-4-mobile"></div>
                                    <div class="column is-8 is-8-mobile has-text-centered">
                                        <p class="is-size-4 lastname">{{ previewLastname }}</p>
                                        <p class="is-size-6 firstname">{{ previewFirstnames }}</p>
                                        <p class="is-size-7 dates">*{{ previewDob }} +{{ previewDod }}</p>
                                    </div>
                                </div>
                                <div v-else-if="model == 16" class="columns is-mobile">
                                    <div class="column is-6 is-6-mobile has-text-centered">
                                        <p class="is-size-5 lastname">{{ previewLastname }}</p>
                                        <p class="is-size-6 firstname">{{ previewFirstnames }}</p>
                                        <p class="is-size-7 dates">*{{ previewDob }} +{{ previewDod }}</p>
                                    </div>
                                </div>
                                <div v-else-if="model == 17" class="columns is-mobile is-flex is-vcentered is-centered">
                                    <div class="column is-12 is-12-mobile has-text-centered elaman-tuli-margin">
                                        <p class="is-size-4 lastname elaman-tuli-lastname-margin">{{ previewLastname }}</p>
                                        <p class="is-size-6 firstname">{{ previewFirstnames }}</p>
                                        <p class="is-size-7 dates">*{{ previewDob }} +{{ previewDod }}</p>
                                    </div>
                                </div>
                                <div v-else-if="model == 18" class="columns is-mobile design-lg-area">
                                    <div class="column is-12 is-12-mobile has-text-centered">
                                        <div class="columns is-mobile">
                                            <div class="column is-12 is-12-mobile">
                                                <p class="is-size-4 lastname">{{ previewLastname }}</p>
                                            </div>
                                        </div>
                                        <div class="columns is-mobile bg-19 is-flex is-vcentered is-centered">
                                            <div class="bg-19-flower"></div>
                                            <div class="column is-10 is-10-mobile">
                                                <p class="is-size-6 firstname">{{ previewFirstnames }}</p>
                                                <p class="is-size-7 dates">*{{ previewDob }}</p>
                                                <p class="is-size-7 dates">+{{ previewDod }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="model == 9 || model == 10 || model == 11" class="has-text-left design-area" :class="models[model].stone.options[stone].class + models[model].stone.options[stone].bg">
                            <div v-if="models[model].stone.options[stone].option" class="design-area-option" :class="models[model].stone.options[stone].option"></div>
                            <div class="design-text-area" :class="[models[model].color.options[color].class, models[model].font.options[font].class]">
                                <div class="columns is-mobile" :class="{'design-lg-area': model == 10 || model == 11}">
                                    <div class="column is-12 is-12-mobile has-text-centered" v-if="models[model].decoration.options[decoration].class != '' || model == 11">
                                        <div class="columns is-mobile">
                                            <div class="column is-4 is-4-mobile decoration-slot">
                                                <div class="decoration-center" v-if="models[model].decoration.options[decoration].size == 'sm'" :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type"></div>
                                                <div class="decoration-center" v-else-if="models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                            </div>
                                        </div>
                                        <div class="columns is-mobile" v-if="model == 10">
                                            <div class="column is-12 is-12-mobile">
                                                <p class="is-size-4 lastname">{{ previewLastname }}</p>
                                            </div>
                                        </div>
                                        <div class="columns is-mobile" :class="{'design-lg-area': models[model].decoration.options[decoration].size == 'lg'}">
                                            <div class="column is-3 is-3-mobile decoration-lg-spacing-right" v-if="models[model].decoration.options[decoration].size == 'lg'">
                                                <div :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type"></div>
                                            </div>
                                            <div class="column" :class="{'is-9 is-9-mobile': models[model].decoration.options[decoration].size == 'lg', 'is-12 is-12-mobile': models[model].decoration.options[decoration].size == 'sm'}">
                                                <p class="is-size-4 lastname" v-if="model == 9 || model == 11">{{ previewLastname }}</p>
                                                <p class="firstname" :class="{'is-size-7': model != 10, 'is-size-6': model == 10}">{{ previewFirstnames }}</p>
                                                <p class="dates" :class="{'is-size-8': model != 10, 'is-size-7': model == 10}">*{{ previewDob }} +{{ previewDod }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-12 is-12-mobile has-text-centered" v-else>
                                        <div v-if="models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                        <div v-if="models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm' && models[model].decoration2.options[decoration2].multiple == true" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type+'-flip'"></div>
                                        <p class="is-size-4 lastname lintu-lastname-no-decoration" v-if="model == 9">{{ previewLastname }}</p>
                                        <p class="is-size-4 lastname uupunut-sydan-lastname-no-decoration" v-else-if="model == 10">{{ previewLastname }}</p>
                                        <p class="is-size-4 lastname" v-else>{{ previewLastname }}</p>
                                        <p class="is-size-7 firstname">{{ previewFirstnames }}</p>
                                        <p class="is-size-8 dates">*{{ previewDob }} +{{ previewDod }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="has-text-left design-area" :class="[models[model].stone.options[stone].class + models[model].stone.options[stone].bg, {'tyyneys-padding': model == 12}]">
                            <div v-if="models[model].stone.options[stone].option" class="design-area-option" :class="models[model].stone.options[stone].option"></div>
                            <div class="design-text-area" :class="[models[model].color.options[color].class, models[model].font.options[font].class]">
                                <div class="columns is-mobile design-lg-area" v-if="models[model].size.options[size].width >= 80 || (models[model].size.options[size].width >= 60 && models[model].decoration.options[decoration].size == 'lg')">
                                    <div class="column decoration-lg-spacing-right" :class="{'is-2 is-2-mobile': models[model].size.options[size].width >= 110, 'is-3 is-3-mobile': models[model].size.options[size].width < 110}" v-if="models[model].decoration.options[decoration].size == 'lg'">
                                        <div :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type"></div>
                                    </div>
                                    <div class="column has-text-centered" :class="{'is-9 is-9-mobile': (models[model].decoration.options[decoration].size == 'lg' && models[model].size.options[size].width < 110), 'is-10 is-10-mobile': (models[model].decoration.options[decoration].size == 'lg' && models[model].size.options[size].width >= 110), 'is-12 is-12-mobile': models[model].decoration.options[decoration].size == 'sm'}">
                                        <div class="columns is-mobile">
                                            <div class="column" :class="{'is-12 is-12-mobile': models[model].decoration.options[decoration].size != 'sm' && (model == 12 || !models[model].decoration2 || (models[model].decoration2 && models[model].decoration2.options[decoration2].size != 'sm')), 'is-10 is-10-mobile': models[model].decoration.options[decoration].size == 'sm' || (models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm' && model != 12 && (model != 4 || (model == 4 && models[model].decoration.options[decoration].size == 'lg'))), 'is-9 is-9-mobile is-offset-1 is-offset-1-mobile': model == 4 && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm' && models[model].decoration.options[decoration].size != 'lg'}">
                                                <p class="is-size-4 lastname">{{ previewLastname }}</p>
                                                <div class="columns is-mobile">
                                                    <div class="column" :class="{'is-6 is-6-mobile': models[model].size.options[size].width >= 110, 'is-12 is-12-mobile': models[model].size.options[size].width < 110}">
                                                        <p class="firstname" :class="{'is-size-7': model != 12, 'is-size-6': model == 12}">{{ previewFirstnames }}</p>
                                                        <p class="dates" :class="{'is-size-8': model != 12, 'is-size-7': model == 12}">*{{ previewDob }} +{{ previewDod }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="models[model].decoration.options[decoration].size == 'sm' || (models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm')" :class="{'column is-2 is-2-mobile': model != 12}">
                                                <div v-if="models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                                <div v-if="models[model].decoration.options[decoration].size == 'sm'" :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type"></div>
                                                <div v-if="models[model].decoration.options[decoration].size == 'sm' && models[model].decoration.options[decoration].multiple == true" :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type+'-flip'"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="columns is-mobile" v-else-if="models[model].size.options[size].width <= 40">
                                    <div class="column is-12 is-12-mobile has-text-centered">
                                        <div v-if="models[model].decoration.options[decoration].class != '' || model == 13" :class="[models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type, {'decoration-pilvilinna': model == 13 , 'decoration-center': model != 13}]"></div>
                                        <p class="is-size-4 lastname lastname-margin">{{ previewLastname }}</p>
                                        <p class="firstname" :class="{'is-size-7': model != 13, 'is-size-6': model == 13}">{{ previewFirstnames }}</p>
                                        <p class="dates" :class="{'is-size-8': model != 13, 'is-size-7': model == 13}">*{{ previewDob }} +{{ previewDod }}</p>
                                    </div>
                                </div>
                                <div class="columns is-mobile design-lg-area" v-else>
                                    <div class="column is-12 is-12-mobile has-text-centered design-lg-area" v-if="models[model].decoration.options[decoration].class != ''">
                                        <div class="columns is-mobile">
                                            <div class="column" :class="{'is-3 is-3-mobile': models[model].decoration.options[decoration].size == 'sm' || ((model == 0 || model == 4) && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'), 'is-hidden': models[model].decoration.options[decoration].size == 'lg' && ((model != 0 && model != 4) || (models[model].decoration2 && models[model].decoration2.options[decoration2].size != 'sm'))}">
                                                <div class="decoration-center" v-if="models[model].decoration.options[decoration].size == 'sm'" :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type"></div>
                                                <div class="decoration-center decoration-normal" v-if="models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                            </div>
                                            <div class="column" :class="{'is-9 is-9-mobile': models[model].decoration.options[decoration].size == 'sm' || ((model == 0 || model == 4) && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'), 'is-12 is-12-mobile': models[model].decoration.options[decoration].size == 'lg' && ((model != 0 && model != 4) || (models[model].decoration2 && models[model].decoration2.options[decoration2].size != 'sm'))}">
                                                <div v-if="model != 0 && model != 4 && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                                <div v-if="model != 0 && model != 4 && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm' && models[model].decoration2.options[decoration2].multiple == true" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type+'-flip'"></div>
                                                <p class="is-size-4 lastname">{{ previewLastname }}</p>
                                            </div>
                                        </div>
                                        <div class="columns is-mobile" :class="{'design-lg-area': models[model].decoration.options[decoration].size == 'lg'}">
                                            <div class="column decoration-lg-spacing-right" :class="{'is-4 is-4-mobile': model != 7, 'is-3 is-3-mobile': model == 7}" v-if="models[model].decoration.options[decoration].size == 'lg'">
                                                <div :class="models[model].decoration.options[decoration].class+'-'+models[model].color.options[color].type"></div>
                                            </div>
                                            <div class="column is-3 is-3-mobile" v-else-if="model == 6 && models[model].decoration.options[decoration].size == 'sm'">
                                            </div>
                                            <div class="column" :class="{'is-8 is-8-mobile': models[model].decoration.options[decoration].size == 'lg' && model != 4 && model != 7, 'is-12 is-12-mobile': models[model].decoration.options[decoration].size == 'sm' && model != 6 && model != 4, 'is-9 is-9-mobile': (models[model].decoration.options[decoration].size == 'sm' && model == 6 && model != 4) || model == 7, 'is-7 is-7-mobile': model == 4}">
                                                <p class="firstname" :class="{'firstnames-margin-muistolle': model == 6, 'is-size-7': model != 19, 'is-size-6': model == 19}">{{ previewFirstnames }}</p>
                                                <p class="is-size-8 dates" v-if="model != 19">*{{ previewDob }} +{{ previewDod }}</p>
                                                <p class="is-size-7 dates" v-if="model == 19">*{{ previewDob }}</p>
                                                <p class="is-size-7 dates" v-if="model == 19">+{{ previewDod }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-12 is-12-mobile has-text-centered" v-else>
                                        <div class="columns is-mobile">
                                            <div class="column" :class="{'is-3 is-3-mobile': ((model == 0 || model == 4) && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'), 'is-hidden': ((model != 0 && model != 4) || (models[model].decoration2 && models[model].decoration2.options[decoration2].size != 'sm'))}">
                                                <div class="decoration-center decoration-normal" v-if="models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                            </div>
                                            <div class="column" :class="{'is-9 is-9-mobile': ((model == 0 || model == 4) && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'), 'is-12 is-12-mobile': ((model != 0 && model != 4) || (models[model].decoration2 && models[model].decoration2.options[decoration2].size != 'sm'))}">
                                                <div v-if="model != 0 && model != 4 && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm'" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type"></div>
                                                <div v-if="model != 0 && model != 4 && models[model].decoration2 && models[model].decoration2.options[decoration2].size == 'sm' && models[model].decoration2.options[decoration2].multiple == true" :class="models[model].decoration2.options[decoration2].class+'-'+models[model].color.options[color].type+'-flip'"></div>
                                                <p class="is-size-4 lastname" :class="{'lastname-margin': models[model].decoration.options[decoration].size != ''}">{{ previewLastname }}</p>
                                            </div>
                                        </div>
                                        <p class="is-size-7 firstname">{{ previewFirstnames }}</p>
                                        <p class="is-size-8 dates">*{{ previewDob }} +{{ previewDod }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="models[model].bottom.options[bottom].class !== ''" class="design-box-bottom">
                            <div class="design-bottom"></div>
                        </div>
                        <div v-else-if="model == 16" class="design-box-bottom-erottamattomat">
                            <div class="design-bottom"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns" v-if="!priceHidden">
            <div class="column" :class="{ 'has-text-left-tablet': hasTextLeftTablet }">
                <p class="is-size-2 has-text-info has-text-weight-bold">{{ price }} €</p>
                <p class="is-size-7 has-text-info">{{ $t('Sis. ALV 24 % | Asennus + 90 €')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import models from '../models.json';
export default {
    name: 'design-details',
    props: ['model', 'stone', 'color', 'font', 'decoration', 'decoration2', 'size', 'side', 'bottom', 'firstnames', 'lastname', 'dob', 'dod', 'hasTextLeftTablet', 'priceHidden', 'price'],
    data() {
        return {
            models: models,
            activeDetails: false,
        }
    },
    // Example text is shown in the preview until the real details are entered
    computed: {
        previewLastname: function() {
            return this.lastname || 'Sukunimi';
        },
        previewFirstnames: function() {
            return this.firstnames || 'Etunimi';
        },
        previewDob: function() {
            return this.dob || '1.1.1940';
        },
        previewDod: function() {
            return this.dod || '1.1.2020';
        }
    },
	methods: {
		goToModel: function() {
			this.activeDetails = false;
            this.$emit('goToModelSelection', true);
        }
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'Antikva';
    src: url('../assets/fonts/antikva/web-fonts/Antikva.eot') format('embedded-opentype'),
        url('../assets/fonts/antikva/web-fonts/Antikva.woff2') format('woff2'),
        url('../assets/fonts/antikva/web-fonts/Antikva.woff') format('woff');
}
@font-face {
    font-family: 'Groteski';
    src: url('../assets/fonts/groteski/web-fonts/Pronssinen_Groteski.eot') format('embedded-opentype'),
        url('../assets/fonts/groteski/web-fonts/Pronssinen_Groteski.woff2') format('woff2'),
        url('../assets/fonts/groteski/web-fonts/Pronssinen_Groteski.woff') format('woff');
}
@font-face {
    font-family: 'Zurich';
    src: url('../assets/fonts/zurich/web-fonts/ufonts.com_trsah_zurich_calligraphic_italic.eot') format('embedded-opentype'),
        url('../assets/fonts/zurich/web-fonts/ufonts.com_trsah-zurich-calligraphic-italic.woff') format('woff');
}
@font-face {
    font-family: 'Commercial Script';
    src: url('../assets/fonts/comscrtn.TTF') format('truetype');
}

$blue: #60757F;
$gray: #E2E2DD;
$green: #72B2A3;
$white: #ffffff;
$black: #000000;
$dark-gray: #c4c4ba;
$bronze: rgb(254, 242, 186); // bronze and gold uses this color
$chrome: #f1f1f3; // chrome and silver uses this color

@mixin stone-variant($image) {
    background: url($image);
    background-repeat: no-repeat;
    background-size: cover;
    > .design-area-option {
        -webkit-mask-image: url($image);
        mask-image: url($image);
        -webkit-mask-size: cover;
        mask-size: cover;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
    }
}

.design-area-option {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    pointer-events: none;
    z-index: 1;
}

.option-aarni {
    background-image: url('../assets/variants/vihrea-meri-3.jpg');
}
.option-kurun-harmaa {
    background-image: url('../assets/variants/options/option-kurun-harmaa.jpg');
}
.option-black {
    background-color: #000000;
}
.option-mantsala-red {
    background-image: url('../assets/variants/options/option-mantsala-red.jpg');
}
.option-pohjolan-loimu {
    background-image: url('../assets/variants/options/option-pohjolan-loimu.jpg');
}
.option-timanttiharjattu-pohjolan-loimu {
    background-image: url('../assets/variants/options/option-timanttiharjattu-pohjolan-loimu.jpg');
}
.option-savon-helmi {
    background-image: url('../assets/variants/options/option-savon-helmi.jpg');
}
.option-timanttiharjattu-savon-helmi {
    background-image: url('../assets/variants/options/option-timanttiharjattu-savon-helmi.jpg');
}

.is-size-8 {
    font-size: 0.5rem;
}
.lastname-margin {
    margin-bottom: 5px !important;
    margin-top: 3px !important;
}
.decoration-normal {
    transform: none !important;
}
.elon-illassa-lastname-line-height .lastname {
    line-height: 24px !important;
}
.firstnames-margin-muistolle {
    margin-top: -8px !important;
}
.display-size-55-80 .decoration-ikava, .display-size-60-110 .decoration-ikava {
    margin-top: 7px !important;
    height: 88px !important;
    background-position-x: center !important;
}
.decoration-kaiho-risti {
    height: 85px !important;
    margin-top: 5px !important;
}
.display-size-60-80-tyyneys, .valon-luo-lastname-shadow {
    .display-color-gold .lastname, .display-color-silver .lastname {
        text-shadow:rgb(0, 0, 0) 2px 2px 0px, rgb(0, 0, 0) 1px 1px 0px, rgb(0, 0, 0) -1px 1px 0px;
    }
    .display-color-black .lastname {
        text-shadow:rgb(0, 0, 0) 1px 1px 0px, rgb(0, 0, 0) -1px 1px 0px;
    }
}
.valon-luo-lastname-padding {
    .lastname {
        padding-bottom: 5px !important;
    }
}
.column.is-offset-1, .column.is-offset-1-mobile {
    margin-left: 8.33333% !important;
}
.display-font-antikva {
    font-family: 'Antikva' !important;
    text-transform: uppercase;
}
#app .display-font-groteski {
    font-family: 'Groteski' !important;
    text-transform: uppercase;
    .is-size-4 {
        font-size: 1.3rem !important;
        line-height: 1.1 !important;
    }
    .is-size-5 {
        font-size: 1.15rem !important;
        line-height: 1.3 !important;
    }
    .is-size-6 {
        font-size: 0.9rem !important;
        line-height: 1.3 !important;
    }
    .is-size-7 {
        font-size: 0.65rem !important;
        line-height: 1.3 !important;
    }
    .is-size-8 {
        font-size: 0.4rem !important;
        line-height: 1.3 !important;
    }
}
.display-font-zurich {
    font-family: 'Zurich' !important;
}
.display-font-yhtenainen-kauno {
    font-family: 'Commercial Script' !important;
}
.display-color-white p {
    color: #ffffff !important;
}
.display-color-black p {
    color: #000000 !important;
}
.display-color-gold p {
    color: $bronze !important;
}
.display-color-silver p {
    color: $chrome !important;
}
.decoration-slot {
    min-height: 2rem;
}
.tyyneys-padding {
    padding: 10px;
}
.decoration-pilvilinna {
    position: relative !important;
    right: unset !important;
    top: 5px !important;
    height: 1.5rem !important;
    width: 4rem !important;
    background-position: center !important;
    left: 20px !important;
    margin-bottom: 18px !important;
}
.display-variant-black-ikuisuuteen {
    background-color: $black !important;
    .bg-19 {
        background: url('../assets/decorations/Malli19_kuvio.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        height: 70% !important;
    }
    .bg-19-flower {
        background: url('../assets/decorations/Orkidea.png');
        background-size: contain;
        background-repeat: no-repeat;
        width: 2rem;
        height: 100%;
        position: absolute;
        left: 0.5rem;
        top: 5px;
    }
}
.display-size-60-80 .display-variant-savon-helmi-yon-helmi {
    padding-top: 13px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_5_1_1.png');
}
.display-size-60-110 .display-variant-savon-helmi-yon-helmi {
    padding-top: 13px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_5_2_1.png');
}
.display-size-80-60 .display-variant-savon-helmi-yon-helmi {
    padding-top: 20px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_5_3_1.png');
    .decoration-k1-risti-yon-helmi-bronze, .decoration-k5-risti-yon-helmi-bronze, .decoration-k6-risti-yon-helmi-bronze, .decoration-k1-risti-yon-helmi-chrome, .decoration-k5-risti-yon-helmi-chrome, .decoration-k6-risti-yon-helmi-chrome, .decoration-k1-risti-yon-helmi-black, .decoration-k5-risti-yon-helmi-black, .decoration-k6-risti-yon-helmi-black {
        height: 100px !important;
    }
}
.display-size-60-100 .display-variant-black-sateenkaaren-taa {
    padding-top: 13px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_6_1_1.png');
}
.display-size-60-80 .display-variant-black-sateenkaaren-taa {
    padding-top: 13px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_6_2_1.png');
}
.display-size-80-60 .display-variant-black-sateenkaaren-taa {
    padding-top: 13px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_6_3_1.png');
}
.display-size-60-30-muistolle .display-variant-karjalan-vihrea-muistolle {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_7_1_1.png');
    background-position-x: center;
    .design-text-area {
        margin-top: 10px !important;
        .lastname-margin {
            margin-top: 8px !important;
        }
    }
}
.display-size-60-40-muistolle .display-variant-karjalan-vihrea-muistolle {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_7_2_1.png');
    background-position-x: center;
    .design-text-area {
        margin-top: 10px !important;
        .lastname-margin {
            margin-top: 8px !important;
        }
    }
}
.display-size-40-60-muistolle .display-variant-karjalan-vihrea-muistolle {
    padding-top: 5px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_7_3_1.png');
    .design-text-area {
        margin-top: 6px !important;
        padding-bottom: 15px !important;
    }
    .decoration-k1-risti-bronze, .decoration-pk1-risti-bronze, .decoration-k1-risti-chrome, .decoration-pk1-risti-chrome {
        height: 72px !important;
        margin-top: 8px !important;
        background-position-x: center !important;
    }
    .is-9 .columns:first-child, .is-9 > .lastname, .is-9 > .firstname, .is-9 > .dates {
        margin-right: 16px !important;
    }
}
.display-variant-karjalan-vihrea-kaksin {
    padding-top: 10px;
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_8_1_1.png');
    .lastname {
        margin-top: 10px !important;
    }
}
.display-variant-black-siivilla {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_9_2_1.png');
    .design-text-area {
        padding-top: 18px !important;
    }
    .decoration-k1-risti-bronze, .decoration-k5-risti-bronze, .decoration-k6-risti-bronze, .decoration-k1-risti-chrome, .decoration-k5-risti-chrome, .decoration-k6-risti-chrome {
        margin-top: 5px !important;
        height: 90px !important;
        background-position-x: center !important;
    }
}
.lintu-lastname-no-decoration {
    margin-top: 20px !important;
}
.uupunut-sydan-lastname-no-decoration {
    margin-top: 44px !important;
    margin-bottom: 8px !important;
}
.display-size-60-40-lintu .display-variant-kurun-harmaa-lintu {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_10_1_1.png');
    .lastname {
        margin-bottom: 5px !important;
    }
}
.display-size-60-30-lintu .display-variant-kurun-harmaa-lintu {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_10_2_1.png');
    background-position-x: center;
    .lastname {
        margin-bottom: 5px !important;
    }
}
.display-variant-savon-helmi-timanttiharjattu-uupunut-sydan {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_11.png');
    .decoration-k1-risti-bronze, .decoration-k5-risti-bronze, .decoration-k6-risti-bronze, .decoration-k1-risti-chrome, .decoration-k5-risti-chrome, .decoration-k6-risti-chrome {
        height: 80px !important;
        background-position-x: right !important;
    }
}
.display-variant-karjalan-vihrea-hehku {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_12.png');
    .lastname {
        margin-bottom: 5px !important;
    }
    .decoration-lyhty-center {
        background-position: center !important;
    }
}
.display-variant-kurun-harmaa-tyyneys {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_13.png');
    .decoration-pk1-lg-risti-bronze, .decoration-pk3-risti-bronze, .decoration-pk4-risti-bronze, .decoration-pk1-lg-risti-black, .decoration-pk3-risti-black, .decoration-pk4-risti-black {
        margin-top: 12px !important;
        height: 99px !important;
        background-position-x: center !important;
    }
}
.display-variant-savon-helmi-pilvilinna {
    @include stone-variant('../assets/variants/malli-14-muoto-savon-helmi-kiiltava.png');
}
.display-variant-savon-helmi-timanttiharjattu-kastehelmi {
    @include stone-variant('../assets/variants/malli-15-muoto-savon-helmi-timanttiharjattu.png');
    .decoration-center {
        margin-top: 5px !important;
    }
    .lastname {
        margin-top: 12px !important;
    }
    .design-text-area {
        margin-left: 10px !important;
        margin-right: 15px !important;
    }
}
.display-variant-pohjolan-loimu-meren-aalloissa {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_16.png');
}
.display-variant-pohjolan-loimu-erottamattomat {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_17_2.png');
    background-size: contain;
    > .design-area-option {
        -webkit-mask-size: contain;
        mask-size: contain;
    }
}
.display-variant-pohjolan-loimu-elaman-tuli {
    @include stone-variant('../assets/variants/stone/Joutsenkivi_hautakivi_verkosta_18.png');
}
.elaman-tuli-margin {
    margin-left: 20px !important;
}
.elaman-tuli-lastname-margin {
    margin-bottom: 10px !important;
}
.decoration-pk1-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/PK1_pieni_kirkas_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk1-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/PK1_pieni_kromi_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk1-risti-black {
    height: 100%;
    background: url('../assets/decorations/PK1_pieni_tumma_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk1-lg-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Pronssiristi.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk1-lg-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Pronssiristi_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk1-lg-risti-black {
    height: 100%;
    background: url('../assets/decorations/Pronssiristi_tumma.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk3-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Pronssinen_tahkaristi.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk3-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Pronssinen_tahkaristi_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk3-risti-black {
    height: 100%;
    background: url('../assets/decorations/Pronssinen_tahkaristi_tumma.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk4-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/pronssinen_kieloristi.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk4-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/pronssinen_kieloristi_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-pk4-risti-black {
    height: 100%;
    background: url('../assets/decorations/pronssinen_kieloristi_tumma.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Risti_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-small-bronze {
    height: 100%;
    background: url('../assets/decorations/Risti_kullattu_pieniin_kiviin.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k5-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Kieloristi_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k6-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Tahkaristi_kullattu_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-yon-helmi-bronze {
    height: 75px;
    background: url('../assets/decorations/Risti_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k5-risti-yon-helmi-bronze {
    height: 75px;
    background: url('../assets/decorations/Kieloristi_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k6-risti-yon-helmi-bronze {
    height: 75px;
    background: url('../assets/decorations/Tahkaristi_kullattu_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-kj2-linnut-bronze {
    height: 100%;
    width: 2.5rem;
    background: url('../assets/decorations/Linnut_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
}
.decoration-kj2-linnut-yon-helmi-bronze {
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Linnut_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: 5px;
}
.decoration-kj1-kyyhkynen-bronze {
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Kyyhky_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 5px;
}
.decoration-kj1-kyyhkynen-flip-bronze{
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Kyyhky_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -5px;
    right: 10px;
    transform: scaleX(-1);
}
.decoration-kj1-kyyhkynen-ikava-flip-bronze{
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Kyyhky_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -5px;
    right: 10px;
    transform: scaleX(-1);
}
.decoration-kj3-ruusu-bronze {
    height: 100%;
    width: 2.5rem;
    background: url('../assets/decorations/ruusu_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
}
.decoration-k1-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Risti_hopeamaalattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-small-chrome {
    height: 100%;
    background: url('../assets/decorations/Risti_hopeamaalattu_pieniin_kiviin.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k5-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Kieloristi_hopeamaalattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k6-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Tahkaristi_hopeamaalattu_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-yon-helmi-chrome {
    height: 75px;
    background: url('../assets/decorations/Risti_hopeamaalattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k5-risti-yon-helmi-chrome {
    height: 75px;
    background: url('../assets/decorations/Kieloristi_hopeamaalattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k6-risti-yon-helmi-chrome {
    height: 75px;
    background: url('../assets/decorations/Tahkaristi_hopeamaalattu_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-kj2-linnut-chrome {
    height: 100%;
    width: 2.5rem;
    background: url('../assets/decorations/Linnut_hopeamaali.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
}
.decoration-kj2-linnut-yon-helmi-chrome {
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Linnut_hopeamaali.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: 5px;
}
.decoration-kj1-kyyhkynen-chrome {
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Kyyhky_valkea_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 5px;
}
.decoration-kj1-kyyhkynen-flip-chrome{
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Kyyhky_valkea_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -5px;
    right: 10px;
    transform: scaleX(-1);
}
.decoration-kj1-kyyhkynen-ikava-flip-chrome{
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Kyyhky_valkea_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -5px;
    right: 10px;
    transform: scaleX(-1);
}
.decoration-kj3-ruusu-chrome {
    height: 100%;
    width: 2.5rem;
    background: url('../assets/decorations/ruusu_valkea_tai_hopea.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
}
.decoration-k1-risti-black {
    height: 100%;
    background: url('../assets/decorations/Risti_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-small-black {
    height: 100%;
    background: url('../assets/decorations/Risti_musta_pieniin_kiviin.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k5-risti-black {
    height: 100%;
    background: url('../assets/decorations/Kieloristi_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k6-risti-black {
    height: 100%;
    background: url('../assets/decorations/Tahkaristi_musta_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k1-risti-yon-helmi-black {
    height: 75px;
    background: url('../assets/decorations/Risti_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k5-risti-yon-helmi-black {
    height: 75px;
    background: url('../assets/decorations/Kieloristi_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-k6-risti-yon-helmi-black {
    height: 75px;
    background: url('../assets/decorations/Tahkaristi_musta_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-kj2-linnut-black {
    height: 100%;
    width: 2.5rem;
    background: url('../assets/decorations/Linnut_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
}
.decoration-kj2-linnut-yon-helmi-black {
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Linnut_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: 5px;
}
.decoration-kj1-kyyhkynen-black {
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Kyyhky_musta_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 5px;
}
.decoration-kj1-kyyhkynen-flip-black{
    height: 100%;
    width: 1.5rem;
    background: url('../assets/decorations/Kyyhky_musta_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -5px;
    right: 10px;
    transform: scaleX(-1);
}
.decoration-kj1-kyyhkynen-ikava-flip-black{
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Kyyhky_musta_fixed.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -5px;
    right: 10px;
    transform: scaleX(-1);
}
.decoration-kj3-ruusu-black {
    height: 100%;
    width: 2.5rem;
    background: url('../assets/decorations/ruusu_musta.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
}
.decoration-pk60-soutaja-bronze {
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Soutaja.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    right: 5px;
}
.decoration-pk60-soutaja-chrome {
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Soutaja_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    right: 5px;
}
.decoration-pk34-joutsenet-bronze {
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Joutsenet_kirkas.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    right: 5px;
}
.decoration-pk31-paaskyset-bronze {
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Pronssipaasky.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    right: 5px;
}
.decoration-pk37-varpuset-bronze {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen.jpg');
    background-size: contain;
    background-repeat: repeat-x;
    position: absolute;
    top: -7px;
    right: 0.65rem;
}
.decoration-pk37-varpuset-bronze-flip {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen2.jpg');
    background-size: contain;
    background-repeat: repeat-x;
    position: absolute;
    top: -7px;
    right: -6px;
}
.decoration-pk37-varpuset-tyyneys-bronze {
    height: 0.75rem;
    width: 2rem;
    background: url('../assets/decorations/Pronssivarpuset.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -26px;
    right: 1.65rem;
}
.decoration-pk37-varpuset-tyyneys-black {
    height: 0.75rem;
    width: 2rem;
    background: url('../assets/decorations/Pronssivarpuset_kromattu_tumma.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -26px;
    right: 1.65rem;
}
.decoration-pk37-varpuset-chrome {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen_kromattu.jpg');
    background-size: contain;
    background-repeat: repeat-x;
    position: absolute;
    top: -7px;
    right: 0.65rem;
}
.decoration-pk37-varpuset-chrome-flip {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen2_kromattu.jpg');
    background-size: contain;
    background-repeat: repeat-x;
    position: absolute;
    top: -7px;
    right: -6px;
}
.decoration-pk37-varpuset-2-bronze {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -11px;
    right: 1.5rem;
}
.decoration-pk37-varpuset-2-bronze-flip {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen2.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -11px;
    right: 0px;
}
.decoration-pk37-varpuset-2-chrome {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen_kromattu.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -11px;
    right: 1.5rem;
}
.decoration-pk37-varpuset-2-chrome-flip {
    height: 0.75rem;
    width: 1rem;
    background: url('../assets/decorations/Pronssivarpunen2_kromattu.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -11px;
    right: 0px;
}
.decoration-left {
    left: 5px !important;
    right: unset !important;
}
.decoration-center {
    position: relative !important;
    right: unset !important;
    left: unset !important;
    top: unset !important;
    height: 1.75rem !important;
    width: 100% !important;
    background-position: center !important;
}
.decoration-center-siivilla {
    position: relative !important;
    right: unset !important;
    left: 12px !important;
    top: -15px !important;
    height: 1.25rem !important;
    width: 100% !important;
    background-position: center !important;
}
.decoration-lyhty-bronze {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_pronssi.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-k1-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_pronssi_risti.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-k5-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_pronssi_kieloristi.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-k6-risti-bronze {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_pronssi_tahkaristi.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-chrome {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-k1-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_kromattu_risti.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-k5-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_kromattu_kieloristi.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-lyhty-k6-risti-chrome {
    height: 100%;
    background: url('../assets/decorations/Pieni_holvilyhty_kromattu_tahkaristi.png');
    background-size: contain;
    background-repeat: no-repeat;
    max-height: 75px;
}
.decoration-pk31-paaskyset-chrome {
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Pronssipaasky_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    right: 5px;
}
.decoration-pk34-joutsenet-chrome {
    height: 100%;
    width: 1rem;
    background: url('../assets/decorations/Joutsenet_kromattu.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    right: 5px;
}
.decoration-kj4-heinat-bronze {
    height: 100%;
    width: 37px;
    background: url('../assets/decorations/Heinat_kullattu.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.decoration-lg-spacing-right {
    margin-top: 2px !important;
    margin-right: 2px !important;
}
.design-details-box {
    position: relative;
    z-index: 30;
}
.design-box {
    position: relative;
    margin-bottom: 20px !important;
    .design-box-bottom {
        position: absolute;
        bottom: -30px;
        z-index: 10;
        width: 100%;
        left: 0;
        .design-bottom {
            height: 1.5em;
            margin: 0 auto;
            background-color: $gray;
            box-shadow: 0 -2px 0 -0.5px $dark-gray,
                        0 -4px 0 -1px $dark-gray,
                        0 -6px 0 -1.5px $dark-gray,
                        0 -8px 0 -2px $dark-gray,
                        0 -10px 0 -2.5px $dark-gray,
                        0 -12px 0 -3px $dark-gray,
                        0 -14px 0 -3.5px $dark-gray,
                        0 -16px 0 -4px $dark-gray,
                        0 -18px 0 -4.5px $dark-gray,
                        0 -20px 0 -5px $dark-gray;
        }
    }
    .design-box-bottom-erottamattomat {
        position: absolute;
        bottom: -15px;
        z-index: 10;
        width: 9.5em;
        left: 50%;
        .design-bottom {
            height: 1.5em;
            margin: 0 auto;
            background-color: $gray;
            box-shadow: 0 -2px 0 -0.5px $dark-gray,
                        0 -4px 0 -1px $dark-gray,
                        0 -6px 0 -1.5px $dark-gray,
                        0 -8px 0 -2px $dark-gray,
                        0 -10px 0 -2.5px $dark-gray,
                        0 -12px 0 -3px $dark-gray,
                        0 -14px 0 -3.5px $dark-gray,
                        0 -16px 0 -4px $dark-gray,
                        0 -18px 0 -4.5px $dark-gray,
                        0 -20px 0 -5px $dark-gray;
        }
    }
}
</style>
